import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BrandList from "./BrandList";
import { getBrandList } from "services/redux/businessItems/action";

const mapStateToProps = (state) => ({
  brandData: state.businessItemReducer.brandList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getBrandList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BrandList);